// AdminLogin.jsx
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/admin/auth/LoginForm.css";

const AdminLogin = () => {
const navigate = useNavigate();
const { baseUrl, regExpChecker } = useContext(AppContext);
const [email, setemail] = useState("");
const [password, setpassword] = useState("");
const [ShowPassword, setShowPassword] = useState(false);
const [loading, setLoading] = useState(false);
const [isAutoLogin, setIsAutoLogin] = useState(false);
const [emailError, setEmailError] = useState("");
const [passwordError, setPasswordError] = useState("");

  // ================= SUBMIT HANDLER =================
  const handleAdminSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/admin/auth/admin-login`, formData)
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true || response.data.status === true) {

          localStorage.setItem("adminEmail", email);
          localStorage.setItem("adminPassword", password);
          localStorage.setItem("adminData", JSON.stringify(response.data.admin));

          navigate("/admin/dashboard");

        }
      })
      .catch((error) => {
        console.log(error);
        alert("Server error");
      });
  };

  // ================= PASSWORD TOGGLE =================
  const toggleAdminPasswordVisibility = () => {
    setShowPassword(!ShowPassword);
  };

  // ================= AUTO LOGIN CHECK =================


  useEffect(() => {
 setLoading(true); 
    setIsAutoLogin(true);
    const savedEmail = localStorage.getItem("adminEmail");
    const savedPassword = localStorage.getItem("adminPassword");

    if (savedEmail && savedPassword) {

      const formData = new FormData();
      formData.append("email", savedEmail);
      formData.append("password", savedPassword);

      axios.post(`${baseUrl}/admin/auth/admin-login`, formData)
        .then((response) => {

          if (response.data.success === true || response.data.status === true) {
            navigate("/admin/dashboard");
          }

        })
        .catch(() => {
          console.log("Auto login failed");
        });

    } else {
      setLoading(false);
      setIsAutoLogin(false);
    }

  }, [navigate]);

if (loading && isAutoLogin) {
  return (
    <div className="admin-loading">
      <div className="loading-box">
        <div className="spinner"></div>
        <h4>Welcome Back 👋</h4>
        <p>Checking your saved login...</p>
      </div>
    </div>
  );
}
  // ================= UI =================
  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        {/* LEFT SIDE */}
        <div className="admin-login-left">
          <div className="admin-login-welcome-text">
            <h1 className="admin-login-welcome-title">
              Welcome Back <br /> Administrator.
            </h1>
            <p className="admin-login-welcome-subtitle">
              AUTHORIZED PERSONNEL ONLY
            </p>
            <p className="admin-login-welcome-desc">
              Use of this system is restricted to authorized users. All activity
              is monitored and logged.
            </p>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="admin-login-right">
          <div className="admin-login-form-header">
            <h2 className="admin-login-form-title">Sign In</h2>
            <p className="admin-login-form-subtitle">
              Enter your credentials to access admin dashboard
            </p>
          </div>

          <form className="admin-login-form" onSubmit={handleAdminSubmit}>
            {/* EMAIL */}
            <div className="admin-form-group">
              <label className="admin-form-label">Email</label>
              <input
                type="text"
                name="email"
                className="admin-form-input"
                placeholder="Enter your email"
                value={email}
                onChange={(event) =>{
                  setemail(event.target.value);
                  setEmailError(regExpChecker("email", event.target.value));
                }}
                required

              />
                  <p style={{ color: "red" }}>{emailError}</p>
            </div>

            {/* PASSWORD */}
            <div className="admin-form-group">
              <label className="admin-form-label">Password</label>
              <div className="admin-password-wrapper">
                <input
                  type={ShowPassword ? "text" : "password"}
                  name="password"
                  className="admin-form-input"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(event) =>{
                    setpassword(event.target.value)
                    setPasswordError(regExpChecker("password", event.target.value));
                  }}
                  required
                />
               <p style={{ color: "red" }}>{passwordError}</p>
                <button
                  type="button"
                  className="admin-show-password-btn"
                  onClick={toggleAdminPasswordVisibility}
                >
                  {ShowPassword ? "HIDE" : "SHOW"}
                </button>
              </div>
            </div>

            {/* REMEMBER */}
            <div className="admin-form-options">
              <label>
                <input type="checkbox" name="remember" /> Remember Me
              </label>
            </div>

            {/* SUBMIT */}
            {/* SUBMIT */}
            <div className="admin-form-group">
              <button
                type="submit"
                className="admin-submit-btn"
                disabled={loading}
              >
                {loading ? "Signing In..." : "Sign In"}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;